import HeroImage from "../../../assets/background-img1.jpeg";
import React, { useState, useEffect } from "react";
import SearchContainer from "./SearchContainer";
import HeroImageMobile from "../../../assets/background-img8.jpeg";
const HeroSection = ({ searchParams, onSearchParamsChange, authUser }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Trust badges component
  const TrustBadges = ({ className = "" }) => (
    <div
      className={`flex flex-wrap items-center justify-center gap-3 md:gap-6 ${className}`}
    >
      {/* Licensed Hotel Badge */}
      <div className="group relative">
        <div className="flex items-center gap-2 px-3 py-2 bg-gray-300/40 backdrop-blur-sm border border-white/20 rounded-full hover:bg-white/15 transition-all duration-300 hover:scale-105">
          <div className="w-6 h-6 bg-gradient-to-br from-emerald-400 to-green-500 rounded-full flex items-center justify-center shadow-lg">
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="text-xs md:text-sm font-semibold text-white drop-shadow-sm">
            Licensed Hotels
          </span>
        </div>
        {/* Tooltip */}
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-black/80 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          Government verified & licensed
        </div>
      </div>

      {/* Trusted by Hotels Badge */}
      <div className="group relative">
        <div className="flex items-center gap-2 px-3 py-2 bg-gray-300/40 backdrop-blur-sm border border-white/20 rounded-full hover:bg-white/15 transition-all duration-300 hover:scale-105">
          <div className="w-6 h-6 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center shadow-lg">
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          </div>
          <span className="text-xs md:text-sm font-semibold text-white drop-shadow-sm">
            10+ Partner Hotels
          </span>
        </div>
        {/* Tooltip */}
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-black/80 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          Selangor & Negeri Sembilan
        </div>
      </div>

      {/* Secure Booking Badge */}
      <div className="group relative">
        <div className="flex items-center gap-2 px-3 py-2 bg-gray-300/40 backdrop-blur-sm border border-white/20 rounded-full hover:bg-white/15 transition-all duration-300 hover:scale-105">
          <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <span className="text-xs md:text-sm font-semibold text-white drop-shadow-sm">
            Secure Booking
          </span>
        </div>
        {/* Tooltip */}
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-black/80 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          SSL encrypted & protected
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Version - Fixed to work with auto height */}
      <div className="hidden md:block relative w-full">
        {/* Hero Background Image */}
        <div className="absolute top-0 left-0 w-full h-[400px] md:h-[450px] lg:h-[500px] overflow-hidden">
          <img
            src={HeroImage}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Text Content */}
        <div className="absolute top-[30px] left-0 w-full flex items-center justify-center z-10">
          <div className="text-center text-white px-4 max-w-4xl">
            <div className="space-y-3 md:space-y-4">
              <h1
                className={`text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold transition-all duration-1000 transform
                  ${
                    isVisible
                      ? "translate-y-0 opacity-100"
                      : "translate-y-10 opacity-0"
                  }`}
              >
                Book Licensed Pet Hotels with Confidence
              </h1>
              <p
                className={`text-sm sm:text-base md:text-lg lg:text-xl max-w-3xl mx-auto transition-all duration-1000 delay-500 transform 
                  ${
                    isVisible
                      ? "translate-y-0 opacity-100"
                      : "translate-y-10 opacity-0"
                  }`}
              >
                Verified Pet Hotels. Instant Booking. Happy Pets.
              </p>

              {/* Trust Badges */}
              <div
                className={`transition-all duration-1000 delay-700 transform 
                  ${
                    isVisible
                      ? "translate-y-0 opacity-100"
                      : "translate-y-10 opacity-0"
                  }`}
              >
                <TrustBadges />
              </div>
            </div>
          </div>
        </div>

        {/* Search Container */}
        <div className="absolute top-[170px] left-0 w-full flex items-start justify-center z-20">
          <div
            className={`w-full pt-4 md:pt-6 transition-all duration-1000 transform 
              ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              }`}
          >
            <SearchContainer
              searchParams={searchParams}
              onSearchParamsChange={onSearchParamsChange}
              authUser={authUser}
            />
          </div>
        </div>

        {/* Invisible spacer to ensure container height - adjusted for trust badges */}
        <div className="invisible pt-[240px]">
          <div className="pt-4 md:pt-6">
            <SearchContainer
              searchParams={searchParams}
              onSearchParamsChange={onSearchParamsChange}
              authUser={authUser}
            />
          </div>
        </div>
      </div>

      {/* Mobile Version - Separate Sections */}
      <div className="md:hidden w-full h-full flex flex-col">
        {/* Hero Image and Text Section - increased height for trust badges */}
        <div className="relative w-full h-[22vh] min-h-[220px] max-h-[280px] overflow-hidden">
          <img
            src={HeroImageMobile}
            alt="Background"
            className="w-full h-full object-cover"
          />

          {/* Text Content Overlay */}
          <div className="absolute inset-0 flex items-center z-10">
            <div className="text-left text-white px-8 sm:px-12 lg:px-20 max-w-xl lg:max-w-2xl">
              <div className="space-y-3">
                <h1
                  className={`text-3xl sm:text-4xl lg:text-5xl font-bold transition-all duration-1000 transform
        ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
        }`}
                >
                  Book Licensed
                  <br />
                  Pet Hotels
                </h1>
                <p
                  className={`text-sm sm:text-base lg:text-lg max-w-xl transition-all duration-1000 delay-500 transform 
          ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
                >
                  Verified Pet Hotels. Instant Booking. Happy Pets.
                </p>

                {/* Trust Badges */}
                <div
                  className={`transition-all duration-1000 delay-700 transform 
          ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
                >
                  {/* <TrustBadges /> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search Container Section */}
        <div className="w-full bg-gray-100 py-2">
          <div
            className={`transition-all duration-1000 transform 
              ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              }`}
          >
            <SearchContainer
              searchParams={searchParams}
              onSearchParamsChange={onSearchParamsChange}
              authUser={authUser}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
